/*
 * changePasswordReducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 19-Sep-2024
 */

import produce from 'immer'
import { actionTypes } from '../actions/changePassword'

const ACTION_HANDLERS = {

  [actionTypes.DO_RESET_SHOW_RESULT]: produce((draft) => {
    draft.showResult = false
  }),
  [actionTypes.SAVE_PASSWORD_REQUEST]: produce((draft) => {
    draft.showResult = false
  }),
  [actionTypes.SAVE_PASSWORD_SUCCESS]: produce((draft) => {
    draft.showResult = 'success'
  }),
  [actionTypes.SAVE_PASSWORD_FAILURE]: produce((draft) => {
    draft.showResult = 'error'
  })
  // @generator reducer:type:action
}

// The initial state of the changePassword
const initialState = {
  showResult: false
}

const changePassword = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default changePassword
